/**
 * Petites préférences de l'appareil (accueil vu, dernier e-mail connecté). Le stockage peut être absent ou
 * refusé (navigation privée) : tout se lit et s'écrit sans jamais lever d'erreur.
 */
export function readItem(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeItem(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Préférence perdue : sans gravité.
  }
}

export function removeItem(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // Rien à faire.
  }
}
